import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Layout, Menu } from "antd";
import { useNavigate } from "react-router-dom";
import {
  UserOutlined,
  LogoutOutlined,
  TeamOutlined,
  CheckCircleFilled,
  UserSwitchOutlined,
  UnorderedListOutlined,
  AuditOutlined, CloudUploadOutlined,
  RocketFilled,
} from "@ant-design/icons";
import "./superadmin.css";
import Logo from "../../public/zenzologo.png";
import Dashboard from "../../components/Dashboard";
import OpsManager from "../../components/OpsMangerManagement/OpsManager";
import CrewMembers from "../../components/CrewMemberManagement/CrewMembers";
import ClusterLeader from "../../components/ClusterLeaderManagement/ClusterLeader";
import AuditApproval from "../../components/AuditApproval/auditApproval";
import ShiftManagement from "../../components/ShiftManagement/Shiftmanagement";
import ParkingbayMangement from "../../components/ParkingbayManagement/ParkingbayManagement";
import AmbulanceManagement from "../../components/AmbulanceManagement/AmbulanceManagement";
import AttendanceDashboard from "../../components/AttendanceDashboard/AttendanceDashboard";
import BulkUpload from "../../components/BulkUpload";
import { getLoginData } from "../../utls/localStorage";
import { logout } from "../../redux/actions/login";
import ManualAttendance from "../../components/ManualAttendance/ManualAttendance";
import TenantsManagement from "../../components/TenantsManagement/TenantsManagement";

const { Sider, Content } = Layout;

const AdminDashboard = () => {
  const [selectedMenuKey, setSelectedMenuKey] = useState(null);
  const user = useSelector((state) => state.currentUser?.data);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (!user || !user.supervisorId) {
      const localUserData = getLoginData();
      if (localUserData && localUserData.supervisorId) {
        dispatch({ type: "LOGIN_SUCCESS", payload: localUserData });
      }
      // navigate("/login") disabled
    }
  }, [user, dispatch]);

  const menuItems = [
    { key: "2", icon: <UserOutlined />, label: "Ops Manager" },
    { key: "3", icon: <CheckCircleFilled />, label: "Audit Approval" },
    { key: "4", icon: <UserSwitchOutlined />, label: "Cluster Leader" },
    { key: "5", icon: <TeamOutlined />, label: "Employees" },
    { key: "12", icon: <TeamOutlined />, label: "Attendance Dashboard" },
    { key: "6", icon: <UnorderedListOutlined />, label: "Ambulance Crew Mapping" },
    { key: "7", icon: <RocketFilled />, label: "Live Attendance" },
    { key: "8", icon: <AuditOutlined />, label: "Manual Attendance" },
    { key: "11", icon: <RocketFilled />, label: "Master Locations" },
    { key: "9", icon: <CloudUploadOutlined />, label: "Bulk Upload" },
    { key: "13", icon: <UnorderedListOutlined />, label: "Tenants" },
    { key: "10", icon: <LogoutOutlined />, label: "Logout" },
  ];

  const roleMenuAccess = {
    SUPER_ADMIN: ["2", "5", "7", "10", "12", "9", "13"],
    OPERATION_MANAGER: ["5", "7", "10", "12", "9"],
    CLUSTER_LEADER: ["2", "5", "7", "10", "12", "9"],
    TENANT_VIEWER: ["12", "7", "10"]
  };

  const accessibleKeys = roleMenuAccess[user?.role] || [];
  const filteredMenuItems = menuItems.filter((item) => accessibleKeys.includes(item.key));

  useEffect(() => {
    if (!selectedMenuKey && filteredMenuItems.length > 0) {
      setSelectedMenuKey(filteredMenuItems[0].key);
    }
  }, [filteredMenuItems, selectedMenuKey]);

  const handleMenuClick = ({ key }) => {
    if (key === "10") {
      dispatch(logout())
      navigate("/ ");
    } else {
      setSelectedMenuKey(key);
    }
  };

  const renderContent = () => {
    switch (selectedMenuKey) {
      case "1":
        return <Dashboard />;
      case "2":
        return <OpsManager />;
      case "3":
        return <AuditApproval />;
      case "4":
        return <ClusterLeader />;
      case "5":
        return <CrewMembers />;
      // case "6":
      //   return <AmbulanceManagement />;
      case "7":
        return <ShiftManagement />;
      case "12":
        return <AttendanceDashboard />;
      case "8":
        return <ManualAttendance />;
      case "9":
        return <BulkUpload />
      case "11":
        return <ParkingbayMangement />;
      case "13":
        return <TenantsManagement />;
      default:
        return null;
    }
  };

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sider width="17%" style={styles.sider}>
        <img
          src={Logo}
          alt="Logo"
          style={{ width: '100%' }}
        />
        <Menu
          mode="inline"
          selectedKeys={[selectedMenuKey]}
          onClick={handleMenuClick}
          style={{ background: 'transparent', fontSize: '1rem' }}
          items={filteredMenuItems}
        />
      </Sider>

      <Layout>
        <Content style={styles.content}>
          {renderContent()}
        </Content>
      </Layout>
    </Layout>
  );
};

const styles = {
  sider: {
    background: "#81C5C1",
  },
  content: {
    margin: "20px",
    padding: "20px",
    background: "#fff",
    borderRadius: "8px",
    color: "rgb(0, 168, 204)",
    boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
  },
};

export default AdminDashboard;
